import { Box, Button, FormControl, InputLabel, makeStyles, MenuItem, Select, TextField } from '@material-ui/core'
import { useForm } from 'hooks/useForm'
import { useOpenComponent } from 'hooks/useOpenComponent'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { editTank } from 'redux/actions/tanks/tanksAction'
import Snackbars from "components/Snackbar/Snackbar.js";
import { createNewTank } from 'redux/actions/tanks/tanksAction'
import { useState } from 'react'
import { convertToMapById } from 'helpers/convertToMap'
import { orderArrayV2 } from 'helpers/orderArray'

const blue = '#0055aa'


const useStyles = makeStyles((theme) => ({
  formControl: {
    marginTop: theme.spacing(6),
    minWidth: 120,
  },
  selectEmpty: {
  },
}));

export const FormTankEdit = (props) => {
  const { handleClose, add } = props
  const classes = useStyles()
  const { tankSelected, addMode } = useSelector(state => state.tanks)
  const { companies, companiesList } = useSelector(state => state.companies)
  const { units } = useSelector(state => state.unitsReducer)
  const { token, rules } = useSelector(state => state.login)
  const [company, setCompany] = useState()
  const [station, setStation] = useState()
  const [unitsByStation, setUnitsByStation] = useState([])
  const [unit, setUnit] = useState()
  const { inputValues, handleInputOnChange, handleNewValues } = useForm({
    name: '',
    latitude: '',
    longitude: '',
    capacity: '',
    type: '',
    uuidAws: '',
    deviceId: '',
  })
  const dispatch = useDispatch()
  const { name, latitude, longitude, capacity, type, uuidAws, deviceId } = inputValues
  const { isOpen:openValues, handleIsOpen:handleOpenValues } = useOpenComponent()
  
  const handleSubmit = () => {
    const parseIntValues = {
      ...tankSelected,
      name,
      latitude: parseFloat(latitude),
      longitude: parseFloat(longitude),
      capacity: parseInt(capacity),
      type,
      idUnit: unit ? unit : tankSelected?.id_unit,
      uuidAws,
      deviceId,
    }
    if(  name.length > 0 && parseIntValues.latitude !== null && parseIntValues.longitude !== null && parseIntValues.capacity > 0 && type.length > 0) {
      if(add && station){
        dispatch(createNewTank(parseIntValues, token))
        handleClose()
      } else {
        dispatch(editTank(tankSelected.id, parseIntValues, token))
        handleClose()
      }
    } else {
      handleOpenValues()
    }
  }
  const handleSelectCompany = (value) => {
    setCompany(value)
  }

  useEffect(() => {
    tankSelected && handleNewValues({
      name: tankSelected.name,
      latitude: tankSelected.latitude,
      longitude: tankSelected.longitude,
      capacity: tankSelected.capacity,
      type: tankSelected.type,
      uuidAws: tankSelected.uuid_aws,
      deviceId: tankSelected.device_id
    })
    // eslint-disable-next-line
  }, [tankSelected])

  useEffect(() => {
    if(station){
      setUnitsByStation( orderArrayV2(Object.keys(units).map(id => units[id]).filter(unit => ( unit.idStation === station)), "number") )
    } 
    // eslint-disable-next-line
  }, [station])
  return (
    <>

    <FormControl fullWidth onSubmit={handleSubmit}>

    {
      add &&
      <FormControl variant="outlined" 
      className={classes.formControl}
      >
          <InputLabel htmlFor="outlined-age-native-simple">Empresa *</InputLabel>
          <Select
            value={company}
            onChange={(e) => handleSelectCompany(e.target.value)}
            label="Empresa"
          >
            <MenuItem value="">
              <em>Seleccione una empresa</em>
            </MenuItem>
            {
              companiesList.map(({ label, value }) => (
                <MenuItem value={value}>{label}</MenuItem>
              ))
            }
          </Select>
        </FormControl>
    }

    {
      company && 
      <FormControl variant="outlined" 
    className={classes.formControl}
    >
        <InputLabel id="demo-simple-select-outlined-label">Planta *</InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          value={station}
          onChange={(e) => setStation(e.target.value)}
          label="Empresa"
        >
          <MenuItem value="">
            <em>Seleccione una estación</em>
          </MenuItem>
          {
            companies[company]?.stations.map(({ id, name }) => (
              <MenuItem value={id}>{name}</MenuItem>
            ))
          }
        </Select>
      </FormControl>
    }
      
    {
      station && <FormControl variant="outlined" 
      className={classes.formControl}
      >
          <InputLabel id="demo-simple-select-outlined-label">Unidad *</InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={unit}
            onChange={(e) => setUnit(e.target.value)}
            label="Empresa"
          >
            <MenuItem value="">
              <em>Seleccione una unidad</em>
            </MenuItem>
            {
              unitsByStation.map(({ id, number }) => (
                <MenuItem value={id}>{number}</MenuItem>
              ))
            }
          </Select>
        </FormControl>
    }


      <TextField type="text" className="input_custom" label="Nombre *" name="name" value={name} onChange={handleInputOnChange} variant="outlined" />
      <TextField type="number" className="input_custom" label="Latitud *" name="latitude" value={latitude} onChange={handleInputOnChange} variant="outlined" />
      <TextField type="number" className="input_custom" label="Longitud *" name="longitude" value={longitude} onChange={handleInputOnChange} variant="outlined" />
      <TextField type="number" className="input_custom" label="Capacidad *" name="capacity" value={capacity} onChange={handleInputOnChange} variant="outlined" />
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel id="demo-simple-select-outlined-label">Tipo *</InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          value={type}
          name="type"
          onChange={handleInputOnChange}
          label="Tipo *"
        >
          <MenuItem value="">
            <em>Seleccione una tipo</em>
          </MenuItem>
          <MenuItem value="VENTA">VENTA</MenuItem>
          <MenuItem value="CARBURACION">CARBURACION</MenuItem>
          <MenuItem value="TRASPASO">TRASPASO</MenuItem>
        </Select>
      </FormControl>
      {
        rules.includes('TANK_DEVICE_ID') && ( <TextField fullWidth type="text" className="input_custom" label="Device ID" name="deviceId" value={deviceId} onChange={handleInputOnChange} variant="outlined" /> )
      }
      {
        rules.includes('TANK_AWS_UUID') && ( <TextField fullWidth type="text" className="input_custom" label="AWS UUID" name="uuidAws" value={uuidAws} onChange={handleInputOnChange} variant="outlined" /> )
      }
      <Box sx={{display: 'flex', justifyContent: 'space-between', marginTop: 30}}>
        <Button size="large" variant="contained" color="secondary" onClick={handleClose}>Cancelar</Button>
        <Button 
          size="large" 
          variant="contained" 
          style={{backgroundColor: blue, color: 'white'}} 
          onClick={handleSubmit}

        >{ addMode ? 'Agregar tanque' : 'Guardar'}</Button>
      </Box>
    </FormControl>
    <Snackbars
        place="tr"
        color='danger'
        message="Campos con * son requeridos"
        open={openValues}
        closeNotification={handleOpenValues}
        close
      /> 
    </>
  )
}
